(() => {
  'use strict';
  const previewLength = 360;
  function expand(section, expanded) {
    const button = section.querySelector('[data-description-toggle]');
    section.querySelector('[data-description-content]').hidden = !expanded;
    section.querySelector('[data-description-preview]').hidden = expanded;
    button.setAttribute('aria-expanded', String(expanded));
    button.querySelector('[data-description-label]').textContent = expanded ? 'Ver menos' : 'Ver mais';
  }
  function initialize(scope) {
    scope.querySelectorAll('[data-product-description]').forEach(section => {
      if (section.dataset.descriptionReady) return;
      section.dataset.descriptionReady = 'true';
      const content = section.querySelector('[data-description-content]');
      content.querySelectorAll('table').forEach((table, index) => {
        if (table.parentElement.classList.contains('product-description-table')) return;
        const wrapper = document.createElement('div');
        wrapper.className = 'product-description-table';
        wrapper.tabIndex = 0;
        wrapper.setAttribute('role', 'region');
        wrapper.setAttribute('aria-label', 'Tabela ' + (index + 1) + ' da descrição. Role para consultar todas as colunas.');
        table.before(wrapper);
        wrapper.append(table);
      });
      const text = content.innerText.replace(/\s+/g, ' ').trim();
      // Short descriptions and media-only content remain completely visible.
      if (text.length <= previewLength + 60) return;
      let excerpt = text.slice(0, previewLength);
      const wordEnd = excerpt.lastIndexOf(' ');
      if (wordEnd > previewLength * .7) excerpt = excerpt.slice(0, wordEnd);
      section.querySelector('[data-description-preview]').textContent = excerpt.replace(/[\s,;:–-]+$/u, '') + '…';
      section.querySelector('[data-description-actions]').hidden = false;
      expand(section, false);
    });
  }
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-description-toggle]');
    if (!button) return;
    const section = button.closest('[data-product-description]');
    const expanding = button.getAttribute('aria-expanded') !== 'true';
    const aboveViewport = section.getBoundingClientRect().top < parseFloat(getComputedStyle(section).scrollMarginTop);
    expand(section, expanding);
    // After reading a long description, collapsing returns to its heading.
    if (!expanding && aboveViewport) section.scrollIntoView({ block: 'start', behavior: 'instant' });
  });
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:block:select', event => {
    const section = event.target.closest('[data-product-description]');
    if (section && !section.querySelector('[data-description-actions]').hidden) expand(section, true);
  });
  initialize(document);
})();
